import React from 'react';
import { CategoryStatistics as CategoryStatisticsComponent } from '../../modules';
import StatisticsContainer from './StatisticsContainer';

const CategoryStatistics = () => (
    <StatisticsContainer>
        <CategoryStatisticsComponent />
    </StatisticsContainer>
);

export default CategoryStatistics;